import React, { useEffect, forwardRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "./Styles.css";

const Vision = forwardRef((props, ref) => {
   useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <section ref={ref} className="vision-section d-flex flex-column align-items-center my-5">
      {/* Title */}
      <h2 className="vision-title text-center mb-5" data-aos="fade-up">
        Our <span className="highlight">vision</span>
      </h2>

      <div className="video-wrapper" data-aos="zoom-in" data-aos-delay="200">
        <iframe
          className="vision-video"
          src="https://www.youtube.com/embed/ScMzIvxBSi4?autoplay=0&rel=0"
          title="Our Vision Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
});

export default Vision;
